import { api, type ApiResponse } from "./client";
import type { InboxMessage } from "@/types/inbox-message";

export const inboxMessagesApi = {
  list: (
    params?: Record<string, string>,
  ): Promise<ApiResponse<InboxMessage[]>> => api.get("/inbox-messages", params),

  get: (id: number): Promise<ApiResponse<InboxMessage>> =>
    api.get(`/inbox-messages/${id}`),

  create: (data: Partial<InboxMessage>): Promise<ApiResponse<InboxMessage>> =>
    api.post("/inbox-messages", data),

  update: (
    id: number,
    data: Partial<InboxMessage>,
  ): Promise<ApiResponse<InboxMessage>> =>
    api.put(`/inbox-messages/${id}`, data),

  delete: (id: number): Promise<ApiResponse<InboxMessage>> =>
    api.del(`/inbox-messages/${id}`),
};
